<template>
  <header class="topbar">
    <div class="topbar__title">{{ title }}</div>

    <div v-if="isRetro" class="topbar__retro">RETRO PREDMETI</div>

    <div class="topbar__spacer"></div>

    <el-dropdown trigger="click">
      <div class="topbar__user">
        <span class="topbar__avatar">{{ initials }}</span>
        <span class="topbar__name">{{ fullName }}</span>
        <i class="el-icon-arrow-down topbar__caret"></i>
      </div>
      <el-dropdown-menu slot="dropdown">
        <router-link to="/logout">
          <el-dropdown-item icon="el-icon-switch-button">Odjava</el-dropdown-item>
        </router-link>
      </el-dropdown-menu>
    </el-dropdown>
  </header>
</template>

<script>
import AuthService from "@/services/auth.service";

const TITLES = [
  { prefix: "/predmeti", title: "Predmeti" },
  { prefix: "/predmet/create", title: "Novi predmet" },
  { prefix: "/predmet/view", title: "Predmet" },
  { prefix: "/reports", title: "Izvještaji" },
  { prefix: "/admin", title: "Administracija" },
];

export default {
  name: "Header",
  computed: {
    user() {
      return AuthService.getUser() || {};
    },
    fullName() {
      return [this.user.first_name, this.user.last_name].filter(Boolean).join(" ");
    },
    initials() {
      return [this.user.first_name, this.user.last_name]
        .filter(Boolean)
        .map((n) => n[0].toUpperCase())
        .join("");
    },
    isRetro() {
      return this.user.first_name === "Retro";
    },
    title() {
      if (this.$route.path === "/") return "Početna";
      const match = TITLES.find((t) => this.$route.path.startsWith(t.prefix));
      return match ? match.title : "Predmeti";
    },
  },
};
</script>

<style lang="scss" scoped>
.topbar {
  height: 54px;
  background: var(--surface);
  border-bottom: 1px solid var(--line);
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 0 18px;
  box-sizing: border-box;
}

.topbar__title {
  font-size: var(--fs-xl);
  font-weight: 600;
  color: var(--ink);
}

.topbar__spacer {
  flex-grow: 1;
}

.topbar__retro {
  padding: 4px 10px;
  border-radius: 999px;
  background: var(--danger-tint);
  border: 1px solid var(--danger-line);
  color: var(--danger);
  font-size: var(--fs-sm);
  font-weight: 700;
  letter-spacing: 0.04em;
}

.topbar__user {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 4px 6px;
  border-radius: var(--r-md);

  &:hover {
    background: var(--surface-alt);
  }
}

.topbar__avatar {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: var(--brand-tint);
  color: var(--brand-ink);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--fs-xs);
  font-weight: 700;
}

.topbar__name {
  font-size: var(--fs-md);
  color: var(--ink-2);
}

.topbar__caret {
  font-size: var(--fs-sm);
  color: var(--ink-4);
}
</style>
